/**
 * Get chip label for encryption type
 * @param {number} encryptionTypeId - The encryption type ID
 * @returns {string} Short label for chip display
 */
export function getEncryptionTypeChipLabel (encryptionTypeId) {
	const labels = {
		1: 'Default',
		2: 'SFMC'
	}
	return labels[encryptionTypeId] || 'Unknown'
}

/**
 * Get chip colour for encryption type
 * @param {number} encryptionTypeId - The encryption type ID
 * @returns {string|undefined} Colour name or undefined for default
 */
export function getEncryptionTypeChipColor (encryptionTypeId) {
	const colors = {
		1: 'primary',
		2: 'secondary'
	}
	return colors[encryptionTypeId]
}

/**
 * Get icon for encryption type
 * @param {number} encryptionTypeId - The encryption type ID
 * @returns {string} Material Design icon name
 */
export function getEncryptionTypeIcon (encryptionTypeId) {
	switch (encryptionTypeId) {
		case 1:
			return 'mdi-key'
		case 2:
			return 'mdi-salesforce'
		default:
			return 'mdi-shield'
	}
}

/**
 * Transforms encryption key objects to include chip data
 * @param {Array} encryptionKeys - Array of encryption key objects
 * @returns {Array} Transformed array with chipLabel and chipColor properties
 */
export function mapEncryptionKeysWithChips (encryptionKeys) {
	if (!encryptionKeys) return []
	return encryptionKeys.map(key => ({
		value: key.encryptionKeyId || key.value,
		text: key.encryptionKeyName || key.text,
		chipLabel: getEncryptionTypeChipLabel(key.encryptionTypeId),
		chipColor: getEncryptionTypeChipColor(key.encryptionTypeId)
	}))
}
